import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import CaseStudyArea from '../components/CaseStudyArea';
import FooterOne from '../components/FooterOne';
import NavBar from '../components/NavBar';

const ProjectDetails = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={'Project Details'} />

      {/* Case Study Area */}
      <CaseStudyArea />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default ProjectDetails;
